import {
  adminRoutes,
  contractsRoutes,
  applicationRoutes,
  HOME_PATH,
  lawyerRoutes,
  managerRoutes,
  SIGN_IN_PATH
} from 'routes/constants.routes'
import { Redirect, Route, Switch } from 'react-router-dom'
import NoMatch from 'pages/NoMatch/NoMatch'
import ContractPage from 'pages/ContractPage/ContractPage'
import ApplicationPage from 'pages/Application/ApplicationPage'
import ContractPrivateRoute from 'routes/ContractPrivateRoute'
import ApplicationPrivateRoute from 'routes/ApplicationPrivateRoute'
import HomePrivateRoute from './routes/HomePrivateRoute'
import { useAuthStore } from './context/AuthStore'
import { useRoutes } from './lib/hooks'
import SignIn from './pages/SignIn/SignIn'

function App() {
  const { authStore, authStoreFunc } = useAuthStore()
  const { lastVisit } = useRoutes()

  const getUser = () => {
    if (authStoreFunc.isAdmin()) return adminRoutes
    if (authStoreFunc.isManager()) return managerRoutes(authStoreFunc.isSoftManager())
    if (authStoreFunc.isLawyer()) return lawyerRoutes
    return adminRoutes
  }

  const privateRoutes = getUser()

  return (
    <>
      <Switch>
        {privateRoutes.map(({ path, component }, i) => (
          <HomePrivateRoute key={`component-path-${path}-${i}`} exact path={path} component={component} />
        ))}
        {contractsRoutes.map((path, i) => (
          <ContractPrivateRoute key={`contract-page-path-${path}-${i}`} exact path={path} component={ContractPage} />
        ))}
        {applicationRoutes.map((path, i) => (
          <ApplicationPrivateRoute
            key={`application-page-path-${path}-${i}`}
            exact
            path={path}
            component={ApplicationPage}
          />
        ))}
        <Route path={SIGN_IN_PATH} render={props => <SignIn {...props} />} />
        <Route
          path={'/'}
          render={() => (
            <Redirect
              to={
                authStore.isLoggedIn
                  ? lastVisit && lastVisit !== SIGN_IN_PATH && !lastVisit.includes('undefined')
                    ? lastVisit
                    : HOME_PATH
                  : SIGN_IN_PATH
              }
            />
          )}
        />
        <Route path="*">
          <NoMatch />
        </Route>
      </Switch>
    </>
  )
}

export default App
